import React from 'react'

import Icon from 'app/components/icons/icon/icon.component'
import PlaySoundSVG from 'app/components/icons/play-sound-icon/play-sound-icon.svg'

type PlaySoundIconProps = {
  width?: number | string
  height?: number | string
  className?: string
}

const PlaySoundIcon = ({
  width = 80,
  height = 80,
  className,
}: PlaySoundIconProps) => (
  <Icon
    className={className}
    src={PlaySoundSVG}
    alt="Play Sound Icon"
    width={width}
    height={height}
  />
)

export default PlaySoundIcon
